export type ClientType = "internal" | "external" | null;

export const useClientType = (): ClientType => {
  const clientId = import.meta.env.VITE_KEYCLOAK_CLIENTID?.split("-")?.at(-1);

  if (clientId === "outbound") {
    return "internal";
  }

  if (clientId === "inbound") {
    return "external";
  }

  return null;
};
